<sm-title-bar pageTitle="Business setup" [backWithParams]="true"></sm-title-bar>
<div class="busness_details_owner" *ngIf="!loader && _entityDetails.length > 0">
  <div class="row">
    <!-- <div class="col-sm-8">
        <div class="business_imgs">
            <img [src]="_entityDetails[0].assetInfo[0].imageThumbUrl" alt=""/>
        </div>
    </div> -->
    <div class="col-sm-12">
      <!-- <div class="business_imgs_sub">
            <img [src]="_entityDetails[0].assetInfo[1].imageThumbUrl" alt=""/>
        </div> -->
      <div class="business_imgs_sub">
        <div
          class="shwo_section"
          *ngIf="
            _entityDetails[0]?.assetInfo &&
            _entityDetails[0]?.assetInfo?.length > 0
          "
        >
          <a (click)="viewMedia()">Show all photos</a>
        </div>
        <div
          *ngIf="
            _entityDetails[0]?.assetInfo &&
            _entityDetails[0]?.assetInfo?.length > 0
          "
        >
          <img
            [src]="_entityDetails[0]?.assetInfo[0]?.imageThumbUrl"
            alt=""
            onerror="this.src='../../../../assets/images/entity_placeholder.png'"
            *ngIf="_entityDetails[0].revenue_model == 1"
          />
          <img
            [src]="_entityDetails[0]?.assetInfo[0]?.imageThumbUrl"
            alt=""
            onerror="this.src='../../../../assets/images/fitness-placeholder.png'"
            *ngIf="_entityDetails[0].revenue_model == 2"
          />
        </div>
        <div
          *ngIf="
            !_entityDetails[0].assetInfo ||
            _entityDetails[0]?.assetInfo?.length == 0
          "
        >
          <img
            src="../../../../assets/images/entity_placeholder.png"
            alt=""
            *ngIf="_entityDetails[0].revenue_model == 1"
          />
          <img
            src="../../../../assets/images/fitness-placeholder.png"
            alt=""
            *ngIf="_entityDetails[0].revenue_model == 2"
          />
        </div>
      </div>
    </div>

    <!-- <div class="row" *ngIf="!_entityDetails[0].assetInfo || _entityDetails[0].assetInfo.length == 0 ">
        <div class="col-sm-12">
        <div class="business_imgs">
         
            <img src="../../../../assets/images/entity_placeholder.png" alt="" *ngIf="_entityDetails[0].revenue_model == 1"/>
            <img src="../../../../assets/images/fitness-placeholder.png" alt="" *ngIf="_entityDetails[0].revenue_model == 2"/>
        </div>
    </div>
 
 </div> -->

    <!-- details data -->
    <!-- <div class="option_ser">
        <button mat-icon-button [matMenuTriggerFor]="homeMenu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #homeMenu="matMenu">
            <button mat-menu-item (click)="uploadMedia()"> <mat-icon class="material-icons-outlined">cloud_upload</mat-icon> <span>Upload media</span> </button>
            <button mat-menu-item (click)="editbusinessdetail()"> <mat-icon class="material-icons-outlined">playlist_add</mat-icon> <span>Edit business details</span>  </button>
            <button mat-menu-item (click)="editservice()"> <mat-icon class="material-icons-outlined">control_point_duplicate</mat-icon> <span>Edit services</span></button>
            <button mat-menu-item (click)="editlocation()"> <mat-icon class="material-icons-outlined">edit_location_alt</mat-icon><span>Edit location</span> </button>
            <button mat-menu-item (click)="deactivateBusiness()"> <mat-icon class="material-icons-outlined">delete</mat-icon><span>Deactivate business</span></button>
        </mat-menu>
    </div> -->
    <input
      class="form-control"
      id="formFile"
      accept="image/*"
      type="file"
      (change)="fileChangeEvent($event)"
      #regnMediaInput
      hidden
    />
    <div class="owner_details_pis">
      <div class="edit_photos_sd" style="cursor: pointer">
        <!-- (click)="uploadBusinessLogo()" -->
        <button mat-icon-button [matMenuTriggerFor]="homeMenu2">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #homeMenu2="matMenu">
          <div>
            <button mat-menu-item (click)="regnMediaInput.click()">
              <mat-icon class="material-icons-outlined">add_a_photo</mat-icon>
              Set logo
            </button>
          </div>
          <button
            mat-menu-item
            (click)="deleteImage(businessLogo)"
            *ngIf="
              businessLogo.imageThumbUrl && businessLogo.imageThumbUrl != 'null'
            "
          >
            <mat-icon class="material-icons-outlined">delete</mat-icon>Remove
            logo
          </button>
        </mat-menu>
      </div>
      <img
        [src]="businessLogo.imageThumbUrl"
        onerror="this.src='../../../../assets/images/no-logo-img.png'"
        alt=""
      />
    </div>

    <!--  -->
    <div class="busn_heading">
      <div class="option_ser">
        <button mat-icon-button [matMenuTriggerFor]="homeMenu">
          <mat-icon fontSet="material-icons-outlined">more_vert</mat-icon>
        </button>
        <mat-menu #homeMenu="matMenu">
          <button mat-menu-item (click)="uploadMedia()">
            <mat-icon class="material-icons-outlined">cloud_upload</mat-icon>
            <span>Upload cover photo</span>
          </button>
          <button mat-menu-item (click)="editbusinessdetail()">
            <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
            <span>Edit business details</span>
          </button>
          <button mat-menu-item (click)="editservice()">
            <mat-icon class="material-icons-outlined"
              >control_point_duplicate</mat-icon
            >
            <span>Edit services</span>
          </button>
          <button mat-menu-item (click)="editlocation()">
            <mat-icon class="material-icons-outlined"
              >edit_location_alt</mat-icon
            ><span>Edit location</span>
          </button>
            <button mat-menu-item (click)="adddomainmapping()">
          <mat-icon class="material-icons-outlined">language</mat-icon
          ><span>Domain mapping</span>
        </button>
            <button mat-menu-item (click)="addexternallinks()">
          <mat-icon class="material-icons-outlined">add_link</mat-icon
          ><span>Social & other links</span>
        </button>
          <button mat-menu-item (click)="deactivateBusiness()">
            <mat-icon class="material-icons-outlined">delete</mat-icon
            ><span>Delete business</span>
          </button>
        </mat-menu>
      </div>
      <div class="bg_bid_section">
        <h3>{{ _entityDetails[0].entityName }}</h3>
        <div class="business_sec">
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">location_on</mat-icon></div>
          <div class="locationmad">
            <p>{{ _entityDetails[0].addressInfo.address_line }}</p>
          </div>
        </div>

        <div class="business_sec">
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">call</mat-icon></div>
          <div class="locationmad">
            <p>
              {{
                _entityDetails[0].entityPhone &&
                _entityDetails[0].entityPhone != "null"
                  ? _entityDetails[0].entity_country_code +
                    " " +
                    _entityDetails[0].entityPhone
                  : "No phone added"
              }}
            </p>
          </div>
        </div>
        <div class="business_sec">
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">mail</mat-icon></div>
          <div class="locationmad">
            <p>
              {{
                _entityDetails[0].entity_email &&
                _entityDetails[0].entity_email != "null"
                  ? _entityDetails[0].entity_email
                  : "No email added"
              }}
            </p>
          </div>
        </div>
        <!-- START -->
        <!-- HAS OWN WEB ADDRESS -->
        <div
          class="business_sec"
          *ngIf="
            _entityDetails[0].business_website_address &&
            _entityDetails[0].business_website_address != 'null'
          "
        >
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">public</mat-icon></div>
          <div class="locationmad">
            <p style="word-break: break-all">
              <a
                class="business_arcf"
                [href]="
                  _entityDetails[0].business_website_address.startsWith('http')
                    ? _entityDetails[0].business_website_address
                    : 'https://' + _entityDetails[0].business_website_address
                "
                target="_blank"
                rel="noopener noreferrer"
                >{{ _entityDetails[0].business_website_address }}</a
              >
            </p>
          </div>
        </div>
        <div
          class="business_sec"
          *ngIf="
            _entityDetails[0].webUrl &&
            _entityDetails[0].webUrl != 'null'
          "
        >
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">public</mat-icon></div>
          <div class="locationmad">
            <p style="word-break: break-all">
              <a
                class="business_arcf"
                [href]="
                  _entityDetails[0].webUrl.startsWith('http')
                    ? _entityDetails[0].webUrl
                    : 'https://' + _entityDetails[0].webUrl
                "
                target="_blank"
                rel="noopener noreferrer"
                >{{ _entityDetails[0].webUrl }}</a
              >
            </p>
          </div>
        </div>
        <!-- END -->
        <div class="business_sec">
          <div class="loc_sec"><mat-icon fontSet="material-icons-outlined">description</mat-icon></div>
          <div class="locationmad">
            <p>{{ _entityDetails[0].entityDesc }}</p>
          </div>
        </div>
      </div>

      <div class="service_info">
        <div class="row">
          <div class="col-sm-12">
            <div class="serv_seingo">
              <h3>Service info</h3>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">corporate_fare</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Business type</h4>
                <!-- <p>{{_entityDetails[0].entity_type == 1 ? 'Business/Shop' : 'Individual professional'}}</p> -->

                <mat-chip-listbox aria-label="Fish selection">
                  <mat-chip>{{
                    _entityDetails[0].entity_type == 1
                      ? "Business/Shop"
                      : "Individual professional"
                  }}</mat-chip>
                </mat-chip-listbox>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">settings_applications</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Services</h4>
                <!-- <p>{{_entityDetails[0].entity_services | servToStr}}</p> -->
                <mat-chip-listbox aria-label="Fish selection">
                  <mat-chip
                    *ngFor="let item of _entityDetails[0].entity_services"
                    >{{ item.service_name }}</mat-chip
                  >
                </mat-chip-listbox>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">wysiwyg</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Service offering</h4>
                <!-- <p>{{_entityDetails[0].provided_services | servToStr}}</p> -->
                <mat-chip-listbox aria-label="Fish selection">
                  <mat-chip *ngIf="_entityDetails[0].shopServiceStatus != 2"
                    >Shop</mat-chip
                  >
                  <mat-chip *ngIf="_entityDetails[0].homeServiceStatus != 2"
                    >Home</mat-chip
                  >
                  <mat-chip
                    *ngIf="_entityDetails[0].virtual_service_status != 2"
                    >Virtual</mat-chip
                  >
                </mat-chip-listbox>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh" style="border-right: none !important">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Target customer</h4>
                <!-- <p *ngIf="_entityDetails[0].service_target_type == 1">Ladies</p>
                    <p *ngIf="_entityDetails[0].service_target_type == 2">Gents</p>
                    <p *ngIf="_entityDetails[0].service_target_type == 3">Unisex</p> -->
                <mat-chip-listbox aria-label="Fish selection">
                  <mat-chip *ngIf="_entityDetails[0].service_target_type == 1"
                    >Ladies</mat-chip
                  >
                  <mat-chip *ngIf="_entityDetails[0].service_target_type == 2"
                    >Gents</mat-chip
                  >
                  <mat-chip *ngIf="_entityDetails[0].service_target_type == 3"
                    >Unisex</mat-chip
                  >
                </mat-chip-listbox>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- owner info -->

      <div class="service_info">
        <div class="row">
          <div class="col-sm-12">
            <div class="serv_seingo">
              <h3>Owner info</h3>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">person</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Owner name</h4>
                <p>
                  {{
                    _entityDetails[0].ownerName &&
                    _entityDetails[0].ownerName != "null"
                      ? _entityDetails[0].ownerName
                      : "No info available"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">call</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Business number</h4>
                <p>
                  {{
                    _entityDetails[0].entityPhone &&
                    _entityDetails[0].entityPhone != "null"
                      ? _entityDetails[0].entity_country_code +
                        " " +
                        _entityDetails[0].entityPhone
                      : "No info available"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">call</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Owner phone number</h4>
                <p>
                  {{
                    _entityDetails[0].ownerPhone &&
                    _entityDetails[0].ownerPhone != "null"
                      ? _entityDetails[0].owner_country_code +
                        " " +
                        _entityDetails[0].ownerPhone
                      : "No info available"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6">
            <div class="service_listh" style="border-right: none !important">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">article</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Registration number</h4>
                <p>
                  {{
                    _entityDetails[0].referenceNo &&
                    _entityDetails[0].referenceNo != "null"
                      ? _entityDetails[0].referenceNo
                      : "No info available"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- end -->

      <!-- Business info start -->

      <div class="service_info">
        <div class="row">
          <div class="col-sm-12">
            <div class="serv_seingo">
              <h3>Business info</h3>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">public</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Country</h4>
                <p>{{ _entityDetails[0].addressInfo.country }}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="service_listh">
              <div class="bus_icon">
                <mat-icon fontSet="material-icons-outlined">language</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Currency code</h4>
                <p>
                  {{
                    _entityDetails[0].currency
                      ? _entityDetails[0].currency
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="service_listh">
              <div class="bus_icon">
                <img
                  src="/assets/images/universal-currency.svg"
                  alt=""
                  style="width: 25px; position: relative; bottom: 7px"
                />
              </div>
              <div class="bus_hjk">
                <h4>Currency symbol</h4>
                <p>
                  {{
                    _entityDetails[0].currency_symbol
                      ? _entityDetails[0].currency_symbol
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
          </div>

        


        </div>
      </div>


        <div class="service_info">
        <div class="row">
          <div class="col-sm-12">
            <div class="serv_seingo">
              <h3>Domain info</h3>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="service_listh">
              <div class="bus_icon">
               <mat-icon fontSet="material-icons-outlined">dns</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Domain name</h4>
                <p>
                                {{this._entityDetails[0]?.domain_details?.domain_name ? this._entityDetails[0]?.domain_details?.domain_name : 'No domain mapped yet '}} 
 
                </p>
              </div>
            </div>
          </div>

          <div class="col-sm-6" *ngIf="this._entityDetails[0]?.domain_details?.domain_name">
            <div class="service_listh">
              <div class="bus_icon">
               <mat-icon fontSet="material-icons-outlined">view_kanban</mat-icon>
              </div>
              <div class="bus_hjk">
                <h4>Domain mapping status</h4>
                <p>
                                {{this._entityDetails[0]?.domain_details?.mapping_status == 1 ? 'Domain mapped' : 'In progress'}} 
 
                </p>
              </div>
            </div>
          </div>
          <!--  -->
          </div>
          </div>

      <!-- Business info end -->
    </div>
  </div>
</div>
